<div class="material-download-container">
  <h3 class="material-download-title" [innerHTML]="headline"></h3>
  <div class="headlline-multimedia" *ngIf="multimediaImage && multimediaTitle">
    <div class="headline-multimedia-image">
      <hdi-image [src]="multimediaImage" [alt]="multimediaImageAlt" />
    </div>
    <div class="headline-multimedia-content">
      <div class="headline-multimedia-content-title">
        <h3 [innerHTML]="multimediaTitle"></h3>
      </div>
      <div class="multimedia-list-headline-item">
        <span class="left-icons">
          <hdi-icon
            *ngIf="headlineItem.leftIcon"
            [iconName]="headlineItem.leftIcon"
          ></hdi-icon>
          <p [innerHTML]="headlineItem.label"></p>
        </span>
        <span
          *ngIf="headlineItem.rightIcons && headlineItem.rightIcons.length > 0"
        >
          <button
            *ngFor="let icon of headlineItem.rightIcons; let i = index"
            (pointerenter)="icon.tooltip ? openTooltip(icon.tooltip) : null"
            (pointerleave)="icon.tooltip ? closeTooltip() : null"
            (click)="
              icon.type === 'link' ? copyToClipboard(icon.href, $event) : null
            "
          >
            <ng-container *ngIf="icon.type === 'down-to-line'">
              <a [attr.href]="icon.href" [attr.target]="'_blank'" download>
                <hdi-tooltip
                  *ngIf="
                    tooltip && icon.tooltip && icon.tooltip.id === tooltip.id
                  "
                  [id]="'tooltip' + icon.tooltip.id"
                  [tooltip]="clipboardTooltip ? clipboardTooltip : icon.tooltip"
                  [type]="'hover'"
                ></hdi-tooltip>
                <hdi-icon
                  [iconPrefix]="'far'"
                  [iconName]="getIconName(icon.type)"
                  [size]="Sizes.SMALL"
                ></hdi-icon>
              </a>
            </ng-container>
            <ng-container *ngIf="icon.type !== 'down-to-line'">
              <a [attr.href]="icon.href" [attr.target]="'_blank'">
                <hdi-tooltip
                  *ngIf="
                    tooltip && icon.tooltip && icon.tooltip.id === tooltip.id
                  "
                  [id]="'tooltip' + icon.tooltip.id"
                  [tooltip]="clipboardTooltip ? clipboardTooltip : icon.tooltip"
                  [type]="'hover'"
                ></hdi-tooltip>
                <hdi-icon
                  [iconPrefix]="'far'"
                  [iconName]="getIconName(icon.type)"
                  [size]="Sizes.SMALL"
                ></hdi-icon>
              </a>
            </ng-container>
          </button>
        </span>
      </div>
    </div>
  </div>
  <ng-container *ngIf="multimediaLists.length">
    <ng-container *ngFor="let multimediaList of multimediaLists">
      <hdi-multimedia-list
        [ngClass]="{
          'multimedia-list-extra-padding-x': !multimediaList.backgroundColor,
        }"
        *ngIf="multimediaList.items?.length"
        [viewport]="viewport"
        [multimediaList]="multimediaList"
      ></hdi-multimedia-list
    ></ng-container>
  </ng-container>

  <div *ngIf="projectedContent" class="multimedia-list-separation-line"></div>
  <div class="multimedia-injected-section" *ngIf="projectedContent">
    <h4 class="multimedia-injected-section-headline">
      Weitere Materialien für Sie
    </h4>
    <ng-content></ng-content>
    <ng-container
      *ngIf="crossReferencing"
      class="multimedia-injected-separation-line"
    ></ng-container>
  </div>
</div>
